import React from 'react';
import { useShop } from '../../context/ShopContext';
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ShoppingCart, Check } from 'lucide-react';
import { Link } from 'react-router-dom';

const ProductQuickView = () => {
  const { isQuickViewOpen, closeQuickView, selectedProduct, addToCart } = useShop();

  if (!selectedProduct) return null;

  return (
    <Dialog open={isQuickViewOpen} onOpenChange={closeQuickView}>
      <DialogContent className="sm:max-w-[800px] p-0 overflow-hidden gap-0">
        <div className="grid md:grid-cols-2">
          {/* Image Side */}
          <div className="relative aspect-square md:aspect-auto bg-secondary/20">
            <img 
              src={selectedProduct.image} 
              alt={selectedProduct.name} 
              className="w-full h-full object-cover"
            />
            {selectedProduct.badge && (
               <Badge className="absolute top-4 left-4 z-10 bg-accent text-white border-none px-3 py-1">
                 {selectedProduct.badge}
               </Badge>
            )}
          </div>

          {/* Content Side */}
          <div className="p-6 md:p-8 flex flex-col h-full">
            <div className="mb-auto">
              <div className="flex items-start justify-between mb-2">
                 <div>
                    <p className="text-sm text-muted-foreground mb-1">{selectedProduct.category}</p>
                    <Link to={`/product/${selectedProduct.id}`} onClick={closeQuickView} className="hover:underline">
                      <DialogTitle className="text-2xl md:text-3xl font-serif font-bold text-primary">
                        {selectedProduct.name}
                      </DialogTitle>
                    </Link>
                    <p className="text-sm italic text-muted-foreground font-serif mt-1">
                      {selectedProduct.scientific}
                    </p>
                 </div>
                 <div className="text-right">
                    <p className="text-2xl font-bold text-foreground">kr {selectedProduct.price},-</p>
                    {selectedProduct.originalPrice && (
                      <p className="text-sm text-muted-foreground line-through">kr {selectedProduct.originalPrice},-</p>
                    )}
                 </div>
              </div>

              <div className="py-6 space-y-4">
                <div className="flex items-center gap-2 text-sm text-green-600">
                  <Check className="h-4 w-4" /> 
                  <span>På lager i butikk - Klar for henting</span>
                </div>
                
                <p className="text-muted-foreground leading-relaxed">
                   En robust og hardfør plante som trives godt i vårt klima. 
                   Perfekt for både nybegynnere og erfarne gartnere. 
                   Spør oss gjerne om stellsråd når du henter!
                </p>

                <div className="grid grid-cols-2 gap-4 text-sm mt-4">
                   <div className="bg-secondary/10 p-3 rounded-lg">
                      <span className="block text-muted-foreground text-xs uppercase tracking-wider">Lysforhold</span>
                      <span className="font-medium">Sol / Halvskygge</span>
                   </div>
                   <div className="bg-secondary/10 p-3 rounded-lg">
                      <span className="block text-muted-foreground text-xs uppercase tracking-wider">Vanning</span>
                      <span className="font-medium">Jevn fuktighet</span>
                   </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-3 mt-6 pt-6 border-t">
              <Button 
                size="lg" 
                className="w-full bg-primary hover:bg-primary/90 text-white rounded-full text-lg h-12 shadow-lg"
                onClick={() => {
                  addToCart(selectedProduct);
                  closeQuickView();
                }}
              >
                <ShoppingCart className="mr-2 h-5 w-5" /> Legg i handlekurv
              </Button>
              <Link to={`/product/${selectedProduct.handle || selectedProduct.id}`} onClick={closeQuickView}>
                 <Button variant="outline" className="w-full rounded-full border-primary/20 hover:bg-primary/5 hover:text-primary">
                   Se detaljer
                 </Button>
              </Link>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ProductQuickView;
